import type { ReactNode } from "react";
import { Link } from "wouter";

export interface Crumb {
  label: string;
  href?: string;
}

/** Breadcrumb, title, one-line purpose, and the right-side actions. Exactly one h1 per page. */
export function PageHeader({
  title,
  purpose,
  breadcrumb,
  actions,
}: {
  title: ReactNode;
  purpose?: ReactNode;
  breadcrumb?: Crumb[];
  actions?: ReactNode;
}) {
  return (
    <header className="flex flex-wrap items-start justify-between gap-4">
      <div className="min-w-0">
        {breadcrumb?.length ? (
          <nav aria-label="Breadcrumb" className="mb-1 text-xs text-ink-muted">
            <ol className="m-0 flex list-none flex-wrap items-center gap-1 p-0">
              {breadcrumb.map((c, i) => (
                <li key={c.label} className="flex items-center gap-1">
                  {i > 0 ? <span aria-hidden="true">/</span> : null}
                  {c.href ? (
                    <Link href={c.href} className="text-ink-muted underline-offset-2 hover:text-brand">
                      {c.label}
                    </Link>
                  ) : (
                    <span aria-current="page">{c.label}</span>
                  )}
                </li>
              ))}
            </ol>
          </nav>
        ) : null}
        <h1 className="m-0 font-display text-2xl font-semibold leading-8 text-ink">{title}</h1>
        {purpose ? <p className="m-0 mt-1 text-sm text-ink-muted">{purpose}</p> : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </header>
  );
}
